import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import { SUPPORT_EMAIL } from "../../utils/supportContacts";
import "./billing.css";
import "./billingPlanDetail.css";

export default function BillingPlanDetail() {
  const { planId }  = useParams();
  const location    = useLocation();
  const navigate    = useNavigate();

  const tier         = location.state?.tier         || null;
  const isActive     = !!location.state?.isActive;
  const subscription = location.state?.subscription || null;

  if (!tier) {
    return (
      <div className="billing-detail-page">
        <p className="billing-detail-notfound">Plan not found.</p>
        <button className="gc-icon-btn" onClick={() => navigate("/billing")} data-tip="Back to Billing" aria-label="Back to Billing">
          <ArrowLeft size={16} />
        </button>
      </div>
    );
  }

  const isEnterprise     = tier.id === "enterprise";
  const isContactSales   = tier.contactSales && !tier.requiresPayment;
  const expiresAt        = subscription?.expiresAt
    ? new Date(subscription.expiresAt).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "2-digit" })
    : null;

  const handleAction = () => {
    if (isContactSales) {
      const subject = encodeURIComponent(`${tier.name} Plan Inquiry`);
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}`;
      return;
    }
    navigate(`/billing?autoCheckout=${tier.id}`);
  };

  const actionLabel = isActive
    ? isContactSales ? "Contact Sales" : "Renew Plan"
    : isContactSales ? "Contact Sales"
    : isEnterprise   ? "Pay Enterprise Quote"
    : "Subscribe Now";

  return (
    <div className="billing-detail-page">
      {/* Breadcrumb */}
      <div className="billing-detail-breadcrumb">
        <button className="gc-icon-btn" onClick={() => navigate("/billing")} data-tip="Back to Billing" aria-label="Back to Billing">
          <ArrowLeft size={16} />
        </button>
        <span className="billing-detail-breadcrumb-current">{tier.name}</span>
      </div>

      <div className="billing-detail-card">
        {/* Header */}
        <div className="billing-detail-header">
          <div>
            {tier.featured && <span className="billing-badge">Most Popular</span>}
            {isActive && <span className="billing-badge billing-badge--active">Current Plan</span>}
            <h1 className="billing-detail-title">{tier.name}</h1>
            {tier.description && (
              <p className="billing-detail-desc">{tier.description}</p>
            )}
          </div>

          <div className="billing-detail-price-block">
            <div className="billing-detail-price">
              <span>{tier.price}</span>
              <small>{tier.billing}</small>
            </div>
            {isActive && expiresAt && (
              <p className="billing-detail-expires">Active until {expiresAt}</p>
            )}
          </div>
        </div>

        {/* Features */}
        {tier.features?.length > 0 && (
          <div className="billing-detail-features">
            <h3 className="billing-detail-features-title">What's included</h3>
            <ul className="billing-detail-feature-list">
              {tier.features.map((item) => (
                <li key={item}>
                  <Check size={15} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action */}
        <div className="billing-detail-actions">
          <button
            type="button"
            className="billing-action billing-detail-cta"
            onClick={handleAction}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
